import { Box } from '@chakra-ui/react'
import styled from 'styled-components'

export const ParadeBox = styled(Box)`
    display: flex;
    flex-shrink: 0;
    min-width: fit-content;
    animation: scroll 25s linear infinite;

    &:hover {
        animation-play-state: paused;
    }

    @keyframes scroll {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(-50%);
        }
    }
`
